import React, { Component } from "react";

import Lozenge from "@atlaskit/lozenge";

import { Title } from "../../utils/consts";
import "./footer.css";
export default class Footer extends Component {
  render() {
    const date = new Date();
    return (
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-links">
            <div className="footer-links-block">
              <p className="footer-links-block__title">{Title}</p>
              <ul className="footer-links-list">
                <li className="footer-links-list__item">
                  <span className="list-item__name">Careers</span>
                  <Lozenge className="list-item__lozenge" isBold>
                    new
                  </Lozenge>
                </li>
                <li className="footer-links-list__item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://press.guarentee.ca"
                    className="list-item__link"
                  >
                    <span className="list-item__name">Press</span>
                  </a>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Policies</span>
                </li>
                <li className="footer-links-list__item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://help.guarentee.ca"
                    className="list-item__link"
                  >
                    <span className="list-item__name">Help</span>
                  </a>
                </li>
                <li className="footer-links-list__item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://diversity.guarentee.ca"
                    className="list-item__link"
                  >
                    <span className="list-item__name">Diversity</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-links-block">
              <p className="footer-links-block__title">Discover</p>
              <ul className="footer-links-list">
                <li className="footer-links-list__item">
                  <span className="list-item__name">Blog</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Trust</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Invite Friends</span>
                  <Lozenge className="list-item__lozenge" isBold>
                    New
                  </Lozenge>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Guidebooks</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Events</span>
                </li>
              </ul>
            </div>
            <div className="footer-links-block">
              <p className="footer-links-block__title">Listing</p>
              <ul className="footer-links-list">
                <li className="footer-links-list__item">
                  <span className="list-item__name">Why List</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Refer Listers</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Listing</span>
                  <Lozenge className="list-item__lozenge" isBold>
                    new
                  </Lozenge>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Responsibility</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Community</span>
                </li>
              </ul>
            </div>
            <div className="footer-links-block">
              <p className="footer-links-block__title">F T I</p>
              <ul className="footer-links-list">
                <li className="footer-links-list__item">
                  <span className="list-item__name">Terms</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Privacy</span>
                </li>
                <li className="footer-links-list__item">
                  <span className="list-item__name">Sitemap</span>
                </li>
                <li className="footer-links-list__item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://status.guarentee.ca"
                    className="list-item__link"
                  >
                    <span className="list-item__name">Status</span>
                  </a>
                  <Lozenge className="list-item__lozenge" isBold>
                    new
                  </Lozenge>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-brand">
            <p className="footer-brand__container">
              <span role="img" aria-label="copyright">
                ©
              </span>
              ️ <span className="footer-brand__title" />
              {Title} {date.getFullYear()}
            </p>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js